import {View} from './view';
import {Translations} from '../config/translations';

export class CountdownView extends View {

    render() {
        const countdownForm = document.createElement('div');
        countdownForm.setAttribute('id', 'countdown-form-block');

        countdownForm.innerHTML =
            `<form class='hs-form stacked df-f df-f-countdown' id='df-countdown-form' action=''>
                <fieldset class='form-columns-1 df-fieldset'>
                    <div class='field hs-form-field df-field'>
                        <div id="df-countdown-description" class="df-countdown-description">
                        </div>
                        <div class="df-countdown-timer-section">
                            <div id="df-countdown-timer" class="df-countdown-timer"></div>
                            <div class="df-countdown-timer-labels"><span>HOURS</span><span>MINUTES</span><span>SECONDS</span></div>
                        </div>
                    </div>
                </fieldset>
            </form>`;

        const countdownFormFragment = document.createDocumentFragment();
        countdownFormFragment.appendChild(countdownForm);

        const container = this.getDFContainer();
        container.insertBefore(countdownForm, container.firstChild);
    }

    setTimerValue = (timerValue: string) => {
        this.getHtmlElement('#df-countdown-timer').innerHTML = timerValue;
    }

    startPulsating = () => {
        this.getHtmlElement('#df-countdown-timer').classList.add('pulse');
    }

    setTimerDescription = (value: string) => {
        this.getHtmlElement('#df-countdown-description').innerText = value;
    }

    setDisabledEmail = (value: string) => {
        const emailField = this.getInputElement('[name=email]');
        emailField.disabled = true;
    }

}
